<template>
  <div id="page-container" class="fade page-sidebar-fixed page-header-fixed in">
    <app-header v-if="$store.state.auth.loggedIn"></app-header>
    <app-sidebar v-if="$store.state.auth.loggedIn"></app-sidebar>
    <div class="sidebar-bg" v-if="$store.state.auth.loggedIn"></div>
    <div id="content" class="content">
      <div class="alert alert-danger fade in m-b-15" v-if="$store.state.error.visible">
        {{ $store.state.error.message }}
        <span class="close" data-dismiss="alert" @click="$store.commit('error_dismiss')">&times;</span>
      </div>
      <router-view></router-view>
    </div>
    <app-footer v-if="$store.state.auth.loggedIn"></app-footer>
    <a href="javascript:;" class="btn btn-icon btn-circle btn-success btn-scroll-to-top fade" data-click="scroll-top">
      <i class="fa fa-angle-up"></i>
    </a>
  </div>
</template>
<script>
import Header from '@/components/layout/Header'
import Sidebar from '@/components/layout/Sidebar'
import Footer from '@/components/layout/Footer'
import Login from '@/components/auth/Login'

import auth from '@/services/auth.js'

export default {
  name: 'app',
  components: {
    'app-header': Header,
    'app-sidebar': Sidebar,
    'app-footer': Footer,
    'app-login': Login
  },
  watch: {
    '$store.state.auth.loggedIn': function(loggedIn) {
      if(!loggedIn) {
        this.$router.push('/login')
      }
    },
  },
  methods: {
    async switchColor(){
      setTimeout(() => {
        document.querySelector('body').style.background = 'white';
        document.querySelector('.nav-header').style.display = 'none';
        document.querySelector('.sidebar').style.background = 'white';
        document.querySelector('.sidebar').style.border = '1px solid lightgray';
        document.querySelector('.content').style.background = 'white';
        document.querySelector('.footer').style.background = 'white';
        document.querySelector('.panel-inverse>.panel-heading').style.background = '#10AA85'
        document.querySelector('.panel-inverse>.panel-heading').style.color = 'white'
        document.querySelector('.sidebar-minify-btn').style.background = 'gray'
      }, 1000);
      this.$forceUpdate()
      await this.$nextTick();
    }
  },
  mounted: function() {
    var context = this
    this.$ls.on('logged_in', function(loggedIn) {
      if(!loggedIn) {
        context.$store.commit('auth_destroyed')
      }
    })

    if(!this.$ls.get('logged_in')) {
      this.$router.push('/login')
    } else {
      var token = this.$ls.get('token');
      auth.doValidateToken(token, function(validateTokenResult) {
        context.$store.commit('auth_authenticated', validateTokenResult.scopes)
      })
    }
    if(sessionStorage.getItem('theme') === 'new') {
      this.switchColor()
    }
  },
}
</script>

<style lang="scss">
  @import url('./styles.scss');
</style>



// WEBPACK FOOTER //
// App.vue?6130141f